import { Box, Button, TextField, Link } from '@mui/material'
import { useState } from 'react'
import Modal from './Modal'
import { api } from '../requests/axios'
import { useNavigate } from 'react-router-dom'

interface LoginModalProps {
  open: boolean
  onClose: () => void
  onSuccess: (email: string, token: string) => void
  onForgotPassword: () => void
}

export default function LoginModal({ open, onClose, onSuccess, onForgotPassword }: LoginModalProps) {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const navigate = useNavigate()

  const isFormValid = (): boolean => {
    return username.trim() !== '' && password.trim() !== ''
  }

  const handleLogin = async () => {
    if (!isFormValid()) {
      return
    }

    try {
      let body = { session: { email: username, password: password }}
      const response = await api.post((process.env.REACT_APP_API_PROXY_URL || '').concat(`/session.json`), body)
      const data = await response.data

      if(response.status === 200) {
        onSuccess(data.email, data.authentication_token)
        navigate("/color-charts")
      } else {
        alert('Invalid email or password')
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.errors?.[0] || 
                          error?.response?.data?.error || 
                          'Login failed. Please check your email and password and try again.'
      alert(errorMessage)
    }
  }

  if (!open) return null

  return (
    <Modal title="Login" onClose={onClose}>
      <Box sx={{padding: 3}}>
        <TextField
          id="login-email"
          label="Email"
          variant="outlined"
          required
          fullWidth
          sx={{ mb: 2 }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setUsername(event.target.value);
          }}
        />
        <TextField
          id="login-password"
          label="Password"
          type="password"
          variant="outlined"
          required
          fullWidth
          sx={{ mb: 2 }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setPassword(event.target.value);
          }}
          onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === 'Enter') {
              handleLogin();
            }
          }}
        />
        <Button 
          onClick={handleLogin} 
          disabled={!isFormValid()}
          sx={{ mb: 2 }}
        >
          Login
        </Button>
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Link
            component="button"
            variant="body2"
            onClick={onForgotPassword}
            sx={{ cursor: 'pointer', textDecoration: 'none', verticalAlign: 'baseline' }}
          >
            Forgot Password?
          </Link>
        </Box>
      </Box>
    </Modal>
  )
}

